import { useEffect, useState } from "react";
import { useDealer } from "../../../../tools/api";
import { Excel } from "antd-table-saveas-excel";
import { complexDigitToman, convertToGregorian, convertToJalaliWithTime } from "../../../../tools/tools";
import { NotFound } from "../../../../sources/svg/svg";
import { Button, Table } from "antd";
import { ExportOutlined } from "@ant-design/icons";

const WalletSharing = ({ search = [], type = 0, isActive = false }) => {
  const { queryRevenueShareByDate } = useDealer();
  const [isLoadingList, setIsLoadingList] = useState(true);
  const cTable = [
    {
      title: "شماره مشترک",
      dataIndex: "msisdn",
      key: "msisdn",
      width: 150,
    },
    {
      title: "تاریخ خرید",
      dataIndex: "simPurchaseDate",
      key: "simPurchaseDate",
      width: 150,
    },
    {
      title: "نوع تراکنش",
      dataIndex: "purchaseType",
      key: "purchaseType",
      width: 150,
    },
    {
      title: "تاریخ تراکنش",
      dataIndex: "purchaseDate",
      key: "purchaseDate",
      width: 150,
    },
    {
      title: "مبلغ تراکنش (تومان)",
      dataIndex: "purchaseAmount",
      key: "purchaseAmount",
      width: 150,
    },
    {
      title: "سهم از تراکنش (تومان)",
      dataIndex: "shareOfPurchase",
      key: "shareOfPurchase",
      width: 150,
    },
  ];

  const [bTable, setBTable] = useState([]);
  //state current page show Records
  const [currentPage, setCurrentPage] = useState(0);
  // state totalRecord
  const [totalRecord, setTotalRecord] = useState(0);

  const handleExport = () => {
    const excel = new Excel();
    let tempTable = bTable.map((item) => {
      return {
        ...item,
        msisdn: item.msisdn.props.children,
        purchaseAmount: item.purchaseAmount.props.children,
        shareOfPurchase: item.shareOfPurchase.props.children,
      };
    });
    excel.addSheet("سهم از فروش").addColumns(cTable).addDataSource(tempTable, { str2Percent: true }).saveAs("export.xlsx");
  };

  const handleSearch = async (value) => {
    try {
      setIsLoadingList(true);
      let payload = {
        wallettype: type,
        dateto: convertToGregorian(value[1], "-", "-"),
        datefrom: convertToGregorian(value[0], "-", "-"),
        searchconfigmodel: {
          sort: "",
          filter: "",
          entriesperpage: 10,
          page: currentPage === 0 ? 0 : currentPage - 1,
          totalrowcount: 0,
        },
      };
      let response = await queryRevenueShareByDate(payload);
      if (response) {
        setBTable(
          response.Result.map((item, key) => ({
            key: key,
            msisdn: <span dir="ltr">{item.msisdn}</span>,
            simPurchaseDate: convertToJalaliWithTime(item.spPurchaseDate),
            purchaseType: item.chargeType,
            purchaseDate: convertToJalaliWithTime(item.purchaseDate),
            purchaseAmount: <span dir="ltr">{complexDigitToman(item.purchaseAmount) || 0}</span>,
            shareOfPurchase: <span dir="ltr">{complexDigitToman(item.chargeAmount) || 0}</span>,
          })),
        );
        setTotalRecord(response?.searchconfigmodel?.totalrowcount);
      }
      setIsLoadingList(false);
    } catch (error) {
      console.error(error);
      setIsLoadingList(false);
    }
  };

  useEffect(() => {
    const callServices = async () => {
      try {
        if (search) {
          console.log(search);
          handleSearch(search);
        }
      } catch (error) {
        console.error(error);
      }
    };
    if (isActive) {
      callServices();
    }
  }, [currentPage, search]);

  return (
    <>
      <div className="holder-top-table">
        <div className="holder-button">
          <Button onClick={handleExport} icon={<ExportOutlined />} className="btn-normal btn-print">
            {" "}
            خروجی اکسل{" "}
          </Button>
        </div>
      </div>

      <Table
        className="tbl-normal"
        columns={cTable}
        loading={isLoadingList}
        locale={{
          emptyText: (
            <>
              <NotFound text={"رکوردی یافت نشد."} />
            </>
          ),
        }}
        pagination={{
          className: "page-pagination",
          // position: [totalRecord.length > 10 ? "bottomLeft" : "none"],
          onChange: (page) => {
            setCurrentPage(page);
          },
          pageSize: 10,
          align: "start",
          current: currentPage === 0 ? 1 : currentPage,
          total: totalRecord,
          showSizeChanger: false,
        }}
        scroll={{ y: "100%" }}
        dataSource={bTable}
      ></Table>
    </>
  );
};

export default WalletSharing;
